import MainLayout from "layouts/main";
import { Navigate } from "react-router-dom";
import { AuthStatus } from "routes";

interface ProtectedRouteProps {
  authStatus: AuthStatus;
  isPending: boolean;
}

export function ProtectedRoute({ authStatus, isPending }: ProtectedRouteProps) {
  if (isPending) return <>Loading</>;
  if (authStatus === "authenticated") return <MainLayout />;
  return <Navigate to="/login" replace />;
}